import React from 'react';
import packageJson from '../../../package.json';
const { version } = packageJson;

const Footer = ({ open }) => {
  return (
    <footer
      className={`w-full py-4 mt-auto bg-surface-low border-t border-border-subtle grid grid-cols-2 sm:grid-cols-3 items-center px-8 transition-[margin-left,width] duration-200 ease-in-out ${
        open ? 'sm:ml-[240px] sm:w-[calc(100%-240px)]' : 'sm:ml-[65px] sm:w-[calc(100%-65px)]'
      }`}
    >
      <p className="text-xs font-medium text-on-surface-muted whitespace-nowrap">La Huerta<sup className="ml-0.5 text-[0.6rem]">®</sup></p>
      <p className="hidden sm:block text-xs font-medium text-on-surface-muted text-center whitespace-nowrap">v{version}</p>
      <div className="flex items-center gap-2 px-3 py-1 bg-surface-card rounded-full border border-border-subtle justify-self-end whitespace-nowrap">
        <span className="w-2 h-2 shrink-0 rounded-full bg-emerald-500 animate-pulse"></span>
        <span className="text-[0.625rem] font-bold text-on-surface-muted uppercase tracking-tighter">Sistemas operativos</span>
      </div>
    </footer>
  );
};

export default Footer;
